import axios from 'axios'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/admin'
  }
}

export default {
  /**
   * Host Manager
   */
  getEqpsString: async (payload) => {
    const result = await axios.get(config().url + config().port + config().service + '/eqps/string', { params: payload })
      .then(response => {
        if (response.status === 200 && response.data != null) {
          return response.data
        } else {
          return []
        }
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  getFabsString: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/fabs/string', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * @summary 호스트 목록 조회
   * @description
   * @param
   */
  getHosts: async (payload, callback, targets) => {
    const url = config().url + config().port + config().service + '/hosts'
    await axios
      .get(url, {}, targets)
      .then(response => {
        callback(response)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  /**
   * @summary 호스트 목록 등록 및 수정
   * @description
   * @param
   */
  saveHosts: async (payload) => {
    const url = config().url + config().port + config().service + '/hosts'

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * @summary 호스트 목록 삭제
   * @description
   * @param
   */
  deleteHosts: async (payload) => {
    const url = config().url + config().port + config().service + '/hosts/delete'

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })

    return result
  },
  getHostEqps: async (payload, callback, targets) => {
    const url = config().url + config().port + config().service + '/host/eqps'

    await axios
      .get(url, { params: payload }, targets)
      .then(response => {
        callback(response)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  saveHostEqps: async (payload) => {
    const url = config().url + config().port + config().service + '/host/eqps'

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })

    return result
  },
  deleteHostEqps: async (payload) => {
    console.log('deleteHostEqpData')
    const url = config().url + config().port + config().service + '/host/eqps/delete'

    const result = await axios
      .post(url, payload.dataList)
      .then(response => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })

    return result
  },

  /**
   * Code Manager
   */
  /**
   * Code Type 조회
   */
  getCodeTypes: async (payload, callback, targets) => {
    const url = config().url + config().port + config().service + '/code-types'
    await axios
      .get(url, {}, targets)
      .then((response) => {
        callback(response)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  /**
   * Code Type 등록
   */
  saveCodeTypes: async (payload) => {
    const url = config().url + config().port + config().service + '/code-types'

    const result = await axios
      .post(url, payload.dataList)
      .then((response) => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * Code Type 삭제
   */
  deleteCodeTypes: async (payload) => {
    const url =
      config().url + config().port + config().service + '/code-types/delete'

    const result = await axios
      .post(url, payload.dataList)
      .then((response) => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * Code 조회
   */
  getCodes: async (payload, callback, targets) => {
    const url = config().url + config().port + config().service + '/codes/' + payload.codeType
    await axios
      .get(url, targets)
      .then((response) => {
        callback(response)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  /**
   * Code 조회
   */
  getCodesWithCallback: async (payload) => {
    const url = config().url + config().port + config().service + '/codes/' + payload.codeType
    const result = await axios
      .get(url)
      .then(response => {
        return response.data == null ? [] : response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  },
  /**
   * Code 등록
   */
  saveCodes: async (payload) => {
    const url = config().url + config().port + config().service + '/codes'

    const result = await axios
      .post(url, payload.dataList)
      .then((response) => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * Code 삭제
   */
  deleteCodes: async (payload) => {
    const url = config().url + config().port + config().service + '/codes/delete'

    const result = await axios
      .post(url, payload.dataList)
      .then((response) => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },

  /**
   * Virtual Manager
   */
  /**
   * Virtual EAP 실행
   */
  runVirtualEapStart: async (payload) => {
    // console.log('startVirtualEap')
    try {
      return await axios.post(config().url + config().port + config().service + '/virtual-eap/start', payload)
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * Virtual EAP 중지
   */
  runVirtualEapStop: async (payload) => {
    // console.log('stopVirtualEap')
    try {
      return await axios.post(config().url + config().port + config().service + '/virtual-eap/stop', payload)
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * Virtual EAP 조회
   */
  getVirtualEaps: async () => {
    try {
      const response = await axios.get(
        config().url + config().port + config().service + '/virtual-eaps'
      )
      if (response.status === 200 && response.data) return response.data
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * EQP Alarm Master 목록 조회
   */
  getEqpAlarms: async (payload) => {
    try {
      let response = await axios.get(
        config().url + config().port + config().service + '/eqp-alarms',
        { params: payload }
      )
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * EQP Alarm Master 등록
   */
  saveEqpAlarms: async (payload) => {
    const url = config().url + config().port + config().service + '/eqp-alarms'

    const result = await axios
      .post(url, payload.dataList)
      .then((response) => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  },
  /**
   * EQP Alarm Master 삭제
   */
  deleteEqpAlarms: async (payload) => {
    const url =
      config().url + config().port + config().service + '/eqp-alarms/delete'

    const result = await axios
      .post(url, payload.dataList)
      .then((response) => {
        return response
      })
      .catch((err) => {
        console.error(err)
      })
    return result
  }
}
